import { StoreError } from '~/common/model'

export enum BarringTypes {
  THEFT_BLOCK = 'THEFT_BLOCK',
  LOSS_BLOCK = 'LOSS_BLOCK',
  WEAR_AND_TEAR_BLOCK = 'WEAR_AND_TEAR_BLOCK',
  FRAUD_BLOCK = 'FRAUD_BLOCK',
  RETURNED_INVOICE_BLOCK = 'RETURNED_INVOICE_BLOCK',
  RISK_BLOCK = 'RISK_BLOCK',
}
export interface Barring {
  id: BarringTypes
  name: string
  active: boolean
}
export interface BarringData {
  total: number
  items: Barring[]
}

export interface ResponseBarring {
  barring: BarringData
  subscriptionId: string
}

export interface FetchBarringRequest {
  subscriptionId: string
  brand: string
  sub: string
}

export interface ErrorResponseBarring {
  error: StoreError
  subscriptionId: string
}
